import "./Teammatch.css";
import bayern from "../../teamImage/bayern.png";
import { NavLink, useParams } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import star from "./star.png";
import backArrow from "../../../../images/arrow.png";
import whiteArrow from "../../../../images/white-arrow.png";
import logo from "../../../../components/images/logo.png";
import Skeleton from "../../../../components/Skeleton";
import { Helmet } from "react-helmet-async";

const Teammatch = ({ dark, myteam, teamId, MyBaseUrl }) => {
  const team = myteam || null;

  const slug = team
    ? `${team.name?.toLowerCase().replace(/\s+/g, "-")}-${team.api_id || team.id}`
    : "";

  const [teamMatches, setTeamMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatches = async () => {
      if (!teamId) return;

      try {
        setLoading(true);

        const res = await fetch(`${MyBaseUrl}/teams/${teamId}/matches`);

        const json = await res.json();

        setTeamMatches(json?.data || []);
      } catch (err) {
        console.log("Match fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, [teamId, MyBaseUrl]);

  const [myFav, setMyFav] = useState({});

  const favorite = (matchId) => {
    setMyFav((prev) => ({
      ...prev,
      [matchId]: !prev[matchId],
    }));
  };

  const matchesRef = useRef(null);

  useEffect(() => {
    if (matchesRef.current) {
      matchesRef.current.scrollIntoView({
        behavior: "auto",
        inline: "center",
        block: "nearest",
      });
    }
  }, []);

  const createSlug = (home, away) => {
    return `${home}-vs-${away}`
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  };

  const [isStickyTop, setIsStickyTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 600) {
        if (window.scrollY >= 98) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      } else {
        if (window.scrollY >= 300) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    console.log("TEAM FROM PARENT:", teamId);
    console.log("TEAM OBJECT:", myteam);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {team?.name
            ? `${team.name} Matches | Fixtures, Results & Live Scores`
            : "Team Matches | Goal Arena"}
        </title>

        <meta
          name="description"
          content={
            team?.name
              ? `View all ${team.name} match fixtures, results, scores, and highlights. Follow live updates, match history, and upcoming games for ${team.name}.`
              : "Explore football match fixtures, results, and live scores for your favorite teams on Goal Arena."
          }
        />

        <meta
          name="keywords"
          content={
            team?.name
              ? `${team.name} matches, ${team.name} fixtures, ${team.name} results, live scores, football matches, ${team?.country}, match schedule`
              : "football matches, live scores, fixtures, match results, soccer schedule"
          }
        />

        <meta
          property="og:title"
          content={
            team?.name
              ? `${team.name} Matches & Fixtures`
              : "Team Matches | Goal Arena"
          }
        />

        <meta
          property="og:description"
          content={
            team?.name
              ? `Check ${team.name} fixtures, results, and match details in one place.`
              : "Follow football match updates, fixtures, and results."
          }
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
        />
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content={
            team?.name ? `${team.name} Matches` : "Team Matches | Goal Arena"
          }
        />

        <meta
          name="twitter:description"
          content={
            team?.name
              ? `Fixtures, results, and match updates for ${team.name}.`
              : "Football match fixtures and results."
          }
        />

        <meta name="twitter:image" content={team?.logo || bayern} />
      </Helmet>

      <div className="homer">
        {loading && <Skeleton dark={dark} count={6} />}

        <div className="teammatchWrapper">
          {/* <NavLink
            to="/teams"
            style={{ textDecoration: "none" }}
            className="ppp">
            <strong
              style={{
                cursor: "pointer",
                backgroundColor: "transparent",
                border: dark ? "none" : "none",
                color: dark ? "white" : "black",
                padding: "5px 10px",
                borderRadius: "5px",
              }}>
              {dark ? (
                <img
                  src={whiteArrow}
                  alt=""
                  className="whitearrow"
                  style={{
                    transform: "rotate(180deg)",
                    scale: "0.7",
                  }}
                />
              ) : (
                <img src={backArrow} alt="" className="blackarrow" />
              )}
            </strong>
          </NavLink> */}

          {/* <section
            className="section1"
            style={
              dark
                ? { backgroundColor: "#272727ff" }
                : { backgroundColor: "whitesmoke" }
            }>
            <div>
              <img src={teamMatches?.logo} alt={team?.name} />
              <h1 style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
                {team?.name}
              </h1>
            </div>

            <span>
              <strong style={dark ? { color: "#e2e1e1ff" } : {}}>
                Country: {team?.country}
              </strong>

              <strong style={dark ? { color: "#e2e1e1ff" } : {}}>
                Stadium: {team?.venue_name}
              </strong>
            </span>

            <nav
              style={
                dark
                  ? {
                      backgroundColor: "#333333ff",
                      color: "#fff",
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      transform: isStickyTop
                        ? "translateX(0%)"
                        : "translateX(0)",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
                  : {
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
              }>
              <ul style={{ backgroundColor: "transparent" }}>
                <NavLink
                  to={`/teams/${slug}`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={
                      dark
                        ? { color: "#fafafaff", backgroundColor: "transparent" }
                        : { backgroundColor: "transparent" }
                    }
                    className="navlink">
                    Overview
                  </li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/news`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="navlink">
                    News
                  </li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/standings`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="navlink">
                    Standings
                  </li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/matches`}
                  style={{ textDecoration: "none" }}>
                  <li
                    ref={matchesRef}
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="myactive">
                    Matches
                  </li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/squad`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="navlink">
                    Squad
                  </li>
                </NavLink>
              </ul>
            </nav>
          </section> */}

          {Array.isArray(teamMatches) && teamMatches.length > 0 ? (
            <h1
              id="h1"
              style={dark ? { color: "#dfdfdfff" } : { color: "#161819" }}>
              Highlighted matches
            </h1>
          ) : (
            <p></p>
          )}

          <section className="myfirstsection">
            {loading && (
              <p style={{ marginTop: "-80px" }}>
                <Skeleton dark={dark} count={6} />
              </p>
            )}

            {teamMatches.map((match, index) => {
              const date = new Date(match?.fixture?.date);

              const matchTime = date.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              });

              const matchDate = date.toLocaleDateString();

              const matchId = match?.fixture?.id;
              const homeTeam = match?.teams?.home;
              const awayTeam = match?.teams?.away;
              const goals = match?.goals;

              return (
                <div key={match?.fixture?.id || index}>
                  <h2
                    style={
                      dark ? { color: "#fafafaff" } : { color: "#161819ec" }
                    }>
                    {match?.league?.name} ({match?.league?.round})
                  </h2>

                  <small style={dark ? { color: "#d1d1d1ff" } : {}}>
                    {matchDate} {matchTime} GMT
                  </small>
                  <div
                    key={matchId || index}
                    className="matchtable"
                    style={
                      dark
                        ? { backgroundColor: "#333333ff", boxShadow: "none" }
                        : { backgroundColor: "white" }
                    }>
                    <span
                      className={
                        match?.fixture?.status?.elapsed > 0 &&
                        match?.fixture?.status?.elapsed < 90 &&
                        match?.fixture?.status?.short !== "FT"
                          ? "live-time myspan"
                          : "myspan"
                      }
                      style={
                        match?.fixture?.status?.elapsed > 0 &&
                        match?.fixture?.status?.elapsed < 90 &&
                        match?.fixture?.status?.short !== "FT"
                          ? {}
                          : dark
                            ? { color: "#dfdfdfff" }
                            : { color: "#3e3f3f" }
                      }>
                      {match?.score?.penalty?.home !== null ||
                      match?.score?.penalty?.away !== null
                        ? "PK"
                        : match?.score?.extratime?.home !== null ||
                            match?.score?.extratime?.away !== null
                          ? "Extra"
                          : match?.fixture?.status?.short === "FT" ||
                              match?.fixture?.status?.elapsed >= 90
                            ? "FT"
                            : match?.fixture?.status?.elapsed
                              ? `${
                                  match.fixture.status.elapsed >= 90 &&
                                  match.fixture.status.extra
                                    ? `${match.fixture.status.elapsed}<sup>+${match.fixture.status.extra}</sup>`
                                    : match.fixture.status.elapsed
                                }'`
                              : match?.fixture?.status?.short === "NS"
                                ? new Date(
                                    match?.fixture?.date,
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })
                                : match?.fixture?.status?.short}
                    </span>

                    <NavLink
                      key={match.fixture.id}
                      to={`/matches/${createSlug(
                        match.teams.home.name,
                        match.teams.away.name,
                      )}/${match.fixture.id}`}
                      state={{ matchId }}
                      style={{ width: "100%" }}>
                      <span
                        className="matchspam"
                        style={{ backgroundColor: "transparent" }}>
                        <nav style={{ backgroundColor: "transparent" }}>
                          <wrap className="MM">
                            <img
                              src={homeTeam?.logo}
                              width="25"
                              alt={homeTeam?.name}
                            />
                            <p
                              style={
                                dark
                                  ? { color: "#dbdbdbff" }
                                  : { color: "#161819" }
                              }>
                              {homeTeam?.name}
                            </p>
                          </wrap>

                          <wrap className="NN">
                            <strong
                              style={
                                dark
                                  ? { color: "#dbdbdbff" }
                                  : { color: "#161819" }
                              }>
                              {goals?.home}
                            </strong>
                          </wrap>
                        </nav>

                        <nav style={{ backgroundColor: "transparent" }}>
                          <wrap className="MM">
                            <img
                              src={awayTeam?.logo}
                              width="25"
                              alt={awayTeam?.name}
                            />
                            <p
                              style={
                                dark
                                  ? { color: "#dbdbdbff" }
                                  : { color: "#161819" }
                              }>
                              {awayTeam?.name}
                            </p>
                          </wrap>

                          <wrap className="NN">
                            <strong
                              style={
                                dark
                                  ? { color: "#dbdbdbff" }
                                  : { color: "#161819" }
                              }>
                              {goals?.away}
                            </strong>
                          </wrap>
                        </nav>
                      </span>
                    </NavLink>

                    <img
                      src={star}
                      alt=""
                      className={myFav[matchId] ? "star" : "nostar"}
                      onClick={() => favorite(matchId)}
                    />
                  </div>
                </div>
              );
            })}
          </section>
        </div>
      </div>
    </>
  );
};

export default Teammatch;
